import React from 'react';
import NotificationRow from './NotificationRow';
import Events from '../hooks/events';

const NotificationsTableRows = ({
  category,
  code,
  columns,
  event,
  items,
}) => {
  const showNotification = Events.useShowNotification(category, { code });
  return (
    items.map((item, index) => (
      <NotificationRow
        key={`notifications_table_row_${item.code}`}
        category={category}
        code={code}
        event={event}
        notification={item}
        upward={index > 4}
        columns={columns}
        showNotification={showNotification}
      />
    ))
  );
};

export default NotificationsTableRows;
